import { muiStyles } from 'utils/design';

export const useStyles = muiStyles({
  container: {
    float: 'right',
  },
});
